var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssociateEvents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5461 4.16667V2.5M7.04606 4.16667V2.5M3.50439 6.66667H18.0877M9.34439 11.8683L10.2061 12.8525C10.2852 12.9433 10.4277 12.9358 10.4977 12.8392L12.2477 10.4167",
    stroke: "#1E1F24",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2959 8.37001C3.2959 6.60751 3.2959 5.72584 3.65923 5.05251C3.98777 4.45193 4.49756 3.97043 5.1159 3.67668C5.82923 3.33334 6.76256 3.33334 8.62923 3.33334H12.9626C14.8292 3.33334 15.7626 3.33334 16.4759 3.67668C17.1034 3.97834 17.6126 4.46001 17.9326 5.05168C18.2959 5.72668 18.2959 6.60834 18.2959 8.37084V12.4642C18.2959 14.2267 18.2959 15.1083 17.9326 15.7817C17.604 16.3823 17.0942 16.8638 16.4759 17.1575C15.7626 17.5 14.8292 17.5 12.9626 17.5H8.62923C6.76256 17.5 5.82923 17.5 5.1159 17.1567C4.49768 16.8631 3.98791 16.3819 3.65923 15.7817C3.2959 15.1067 3.2959 14.225 3.2959 12.4625V8.37001Z",
    stroke: "#1E1F24",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssociateEvents);
export default __webpack_public_path__ + "static/media/associate-events.0c88e44283ef8283e1b116966e35ec0d.svg";
export { ForwardRef as ReactComponent };